const floor = (option, dayjsClass) => {
  dayjsClass.prototype.floor = function (amount, unit) {
    return this.subtract(this.get(unit) % amount, unit).startOf(unit);
  };
};
export default floor;
